import { getAgentUrl } from "src/util/url";

const EVENT_TYPE = {
  CONNECTION_ESTABLISHED: "connection_established",
  ON_MESSAGE_CHUNK: "message_chunk",
  STREAM_COMPLETE: "stream_complete",
};

const streamAIResponse = async (
  params,
  {
    tenantId,
    apiUrl,
    onMessageChunk,
    onError,
    onDone,
    onConnectionEstablished,
    headers = {},
    agentName,
    signal,
  }
) => {
  try {
    const response = await fetch(getAgentUrl({ tenantId, apiUrl, agentName }), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: headers?.Authorization,
        "x-workspace-id": headers?.["x-workspace-id"],
      },
      body: JSON.stringify({
        ...params,
        headers,
        stream: true,
      }),
      signal,
    });

    if (!response.ok) {
      const text = await response.text().catch(() => response.statusText);
      onError(`Server error ${response.status}: ${text}`);
      return;
    }

    if (!response.body) {
      onError("Response has no body");
      return;
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = "";

    let complete = false;

    while (!complete) {
      const { done, value } = await reader.read();

      if (done) {
        if (!complete) {
          onError("Stream ended early.");
        }
        break;
      }

      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split("\n");
      buffer = lines.pop() || "";

      for (const line of lines) {
        if (line.startsWith("data: ")) {
          const data = JSON.parse(line.replace("data: ", ""));

          if (data?.error) {
            onError(data);
            complete = true;
          }

          if (data?.type === EVENT_TYPE.CONNECTION_ESTABLISHED) {
            onConnectionEstablished?.(data);
          }

          if (data?.type === EVENT_TYPE.ON_MESSAGE_CHUNK) {
            onMessageChunk?.(data);
          } else if (data?.type === EVENT_TYPE.STREAM_COMPLETE) {
            onDone(data?.final_message ?? null);
            complete = true;
          }
        }
      }
    }
  } catch (e) {
    if (signal?.aborted) {
      return;
    }
    onError(e);
  }
};

export default streamAIResponse;
